import { apiSlice } from 'store/slices/api/api-slice';

export const productEnumApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        productCategoryList: builder.query<string[], void>({
            query: () => ({
                url: '/product/product-category-enum',
                method: 'GET',
            }),
        }),

        currencyList: builder.query<string[], void>({
            query: () => ({
                url: '/currency-enum',
                method: 'GET',
            }),
        }),

        productPricePaymentMode: builder.query<string[], void>({
            query: () => ({
                url: '/product/price-payment-mode-enum',
                method: 'GET',
            }),
        }),

        productDisplayType: builder.query<string[], void>({
            query: () => ({
                url: '/product/display-type-enum',
                method: 'GET',
            }),
        }),

        productType: builder.query<string[], void>({
            query: () => ({
                url: '/product/product-type-enum',
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useProductCategoryListQuery,
    useProductTypeQuery,
    useCurrencyListQuery,
    useProductPricePaymentModeQuery,
    useProductDisplayTypeQuery,
} = productEnumApi;
